/* Auto-generated from home_header_mobile.html. Do not edit by hand. */
export default function HomeMobileNav() {
  return (
    <>
      <div className={"framer-1gvf5p5-container hidden-iwl1xz hidden-1ybsehl"} data-framer-appear-id={"1gvf5p5"} data-home-mobile-nav={"true"} style={{ willChange: "transform", opacity: 1, transform: "none" }}>
  <header className={"framer-AQ3ek framer-sgcc88 framer-v-15xrotc"} data-border={"true"} data-framer-appear-id={"sgcc88"} data-framer-name={"MOBILE"} style={{ "--border-bottom-width": "1px", "--border-color": "rgba(255, 255, 255, 0.05)", "--border-left-width": "1px", "--border-right-width": "1px", "--border-style": "solid", "--border-top-width": "0px", backdropFilter: "blur(5px)", background: "linear-gradient(rgba(6, 6, 12, 0.2) 0%, rgba(45, 45, 82, 0.2) 100%)", width: "100%", maxWidth: "100%" }}>
    <header className={"framer-5wagqk"}>
      <div className={"framer-1ovhzyo"} data-highlight={"true"} tabIndex={"0"}>
        <div className={"framer-KqLRo framer-vp697j"} style={{ "--43q7um": "rgb(255, 255, 255)" }}>
          <svg viewBox={"0 0 24 24"} width={"24"} height={"24"} aria-hidden={"true"}>
            <path d={"M3 6h18"} fill={"none"} stroke={"rgb(255, 255, 255)"} strokeWidth={"2"} strokeLinecap={"round"}></path>
            <path d={"M3 12h18"} fill={"none"} stroke={"rgb(255, 255, 255)"} strokeWidth={"2"} strokeLinecap={"round"}></path>
            <path d={"M3 18h18"} fill={"none"} stroke={"rgb(255, 255, 255)"} strokeWidth={"2"} strokeLinecap={"round"}></path>
          </svg>
        </div>
      </div>
      <a className={"framer-1p681mc framer-1wi0k6z"} data-border={"true"} data-framer-appear-id={"1p681mc"} data-framer-name={"LOGO"} href={"/"} data-framer-page-link-current={"true"} style={{ "--border-bottom-width": "0px", "--border-color": "rgba(255, 255, 255, 0.05)", "--border-left-width": "1px", "--border-right-width": "1px", "--border-style": "solid", "--border-top-width": "0px" }}>
        <div className={"framer-1p1w0xo"}>
          <div className={"framer-15qy6do"} data-framer-component-type={"RichTextContainer"} style={{ "--extracted-r6o4lv": "rgb(255, 255, 255)" }}>
            <p className={"framer-text"} style={{ "--font-selector": "R0Y7R2Vpc3QgTW9uby1yZWd1bGFy", "--framer-font-family": "\"Geist Mono\", monospace", "--framer-font-size": "calc(var(--framer-root-font-size, 1rem) * 1)", "--framer-line-height": "32px", "--framer-text-color": "var(--extracted-r6o4lv, rgb(255, 255, 255))" }}>LIGHTER</p>
          </div>
          <div className={"framer-sgbw62"}>
            <div data-framer-background-image-wrapper={"true"} style={{ position: "absolute", borderRadius: "inherit", cornerShape: "inherit", inset: "0px" }}>
              <img decoding={"auto"} width={"14"} height={"26"} src={"https://framerusercontent.com/images/k22lnUP5Ao1xIheAoknaPGmdjXk.svg?width=14&height=26"} alt={"Lighter Logo"} />
            </div>
          </div>
        </div>
      </a>
    </header>
    <div className={"framer-1h3npfz"}>
      <div data-framer-component-type={"SVG"} className={"framer-4slo6e"} aria-hidden={"true"}>
        <div className={"svgContainer"}>
          <svg preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg1348121721_263"}></use></svg>
        </div>
      </div>
    </div>
    <div className={"framer-d5xqw7"}>
      <div data-framer-component-type={"SVG"} className={"framer-1iwtqif"} aria-hidden={"true"} style={{ transform: "matrix(0, -1, 1, 0, 0, 0)" }}>
        <div className={"svgContainer"}>
          <svg preserveAspectRatio={"none"} width={"100%"} height={"100%"}><use href={"#svg-1793074187_263"}></use></svg>
        </div>
      </div>
    </div>
  </header>
</div>

    </>
  )
}
